import { FEATURE_IDS, type FeatureId } from "@/config/feature-ids";
import type { FeatureFlag, FeatureManagementPayload } from "@/feature-flags/types";

export const parseFeatureFlags = (raw: string | undefined): FeatureFlag[] => {
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw) as FeatureManagementPayload;
    return parsed.feature_management?.feature_flags ?? [];
  } catch (exception) {
    console.warn("[FeatureFlags] Invalid feature management JSON – all flags disabled.", exception);
    return [];
  }
};

export const buildFeatures = (flags: FeatureFlag[]) => {
  const isEnabled = (id: FeatureId): boolean => flags.some((f) => f.id === id && f.enabled);

  return {
    kretaLogin: isEnabled(FEATURE_IDS.KretaLogin),
    googleLogin: isEnabled(FEATURE_IDS.GoogleLogin),
    register: isEnabled(FEATURE_IDS.Register),
  };
};
